// extracted by mini-css-extract-plugin
export var autocomplete = "InPageFilters-module--autocomplete--1ceb0";
export var checkboxes = "InPageFilters-module--checkboxes--92807";
export var clearRefinements = "InPageFilters-module--clear-refinements--40b05";
export var container = "InPageFilters-module--container--644fd";
export var containerWithNewMobileFilters = "InPageFilters-module--container-with-new-mobile-filters--fc11c";
export var filters = "InPageFilters-module--filters--36bbe";
export var mobileFilters = "InPageFilters-module--mobile-filters--c96fd";
export var openModal = "InPageFilters-module--open-modal--cba07";
export var searchBar = "InPageFilters-module--search-bar--b87e8";